import React from "react";
import "../styleSheets/supportHelpSection.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SupportHelpSection: React.FC = () => {
  const { t } = useTranslation("common");
  return (
    <div className="support-help">
      <div className="support-help__header">
        <div className="support-help__title">
          <span
            className="support-help__icon support-icon"
            aria-hidden="true"
          />
          <h3>{t("pageBody.support.title")}</h3>
        </div>
      </div>

      <p className="support-help__subtitle">{t("pageBody.support.subtitle")}</p>

      <ul className="support-help__list">
        <li className="support-help__item">
          <div className="support-help__itemBody">
            <div className="support-help__value">
              <Link to={"/UserGuide"} className="support-help__link">
                {t("pageBody.support.userGuide")}
              </Link>
            </div>
          </div>
        </li>

        <li className="support-help__item">
          <div className="support-help__itemBody">
            <div className="support-help__value">
              <a
                className="support-help__link"
                href="mailto:support@eterniq.com"
              >
                {t("pageBody.support.email")} support@eterniq.com
              </a>
            </div>
          </div>
        </li>
        <li className="support-help__item">
          <div className="support-help__itemBody">
            <div className="support-help__value">
              <Link to={"/ContactUs"} className="support-help__link">
                {t("header.menu.contact")}
              </Link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default SupportHelpSection;
